import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amountField"]

  select(event) {
    event.preventDefault()
    const amount = event.currentTarget.dataset.amount
    this.amountFieldTargets.forEach(field => {
      field.value = amount
      field.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
